import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { AccountUserModel } from '~/model/AccountUsers'

export default class AccountCompany extends BaseModel {
  id: number | null = null
  name: string = ''
  'is_published': boolean = false
  checkboxValue: boolean = false
  'vacancy_managers': AccountUserModel[] = []
  children?: AccountCompany[] = []

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (Array.isArray(data.vacancy_managers)) {
        this.vacancy_managers = data.vacancy_managers.map(i => new AccountUserModel(i))
      }
    }
  }
}
